<template>
  <section class="sku">
    <div class="spec-block" v-for="spec in displayList" :key="spec.guid">
      <h3 class="spec-name">{{spec.name}}</h3>
      <ul class="spec-list">
        <li class="spec-item"
            :class="{check: it.check, disabled: !it.enable}"
            @click="checkSpecItem(it)"
            v-for="it in spec.list"
            :key="it.text">
          <span>{{it.text}}</span>
        </li>
      </ul>
    </div>
    <div class="sku-divider van-hairline--top"></div>
    <div class="buy-count ">
      <p class="buy-count_label">购买数量</p>
      <van-stepper v-model="count" :disabled="countDisabled" :max="max"/>
    </div>
  </section>
</template>

<script>
  import Sku from './sku.js';

  export default {
	name: 'Sku',
	props: {
	  data: Object,
	  detail: Object,
	  value: Number,
	},
	components: {},
	data() {
	  return {
		sku: null
	  };
	},
	created() {
	  this.initSku();
	},
	methods: {
	  initSku() {
		if (!this.data) return;
		let {skuList, specList} = this.data;
		this.sku = new Sku(specList, skuList);
	  },

	  checkSpecItem(item) {
		if (!item.enable) return;
		this.sku.checkSpecItem(item.guid, item.check ? '' : item.text);
	  },
	},
	computed: {
	  count: {
		get() {
		  return this.value;
		},
		set(v) {
		  this.$emit('input', v);
		}
	  },
	  displayList() {
		if (!this.sku) return [];
		return this.sku.displayList;
	  },
	  priceRange() {
		if (!this.sku) return [];
		return this.sku.priceRange;
	  },
	  filterList() {
		if (!this.sku) return [];
		return this.sku.filterList;
	  },
	  checkedSku() {
		if (this.filterList.length !== 1) return null;
		return this.filterList[0];
	  },
	  max() {
		let max = this.detail.inventory;
		if (this.sku) {
		  max = this.checkedSku ? this.checkedSku.inventoryNumber : 0;
		}
		if (max === -1) return 9999;
		return max;
	  },
	  countDisabled() {
		return this.sku && !this.checkedSku;
	  }
	},
	watch: {
	  checkedSku(now) {
		this.$emit('change', now);
	  },
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .sku {
    padding: 0 10px;

    .spec-block {

      .spec-name {
        font-weight: 400;
        line-height: 24px;
        font-size: 15px;
      }

      .spec-list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -5px;

        .spec-item {
          cursor: pointer;
          border-radius: 2px;
          line-height: 24px;
          padding: 0 10px;
          border: 1px solid #b9b9b9;
          margin: 5px;

          &.check {
            color: #1291F3;
            border-color: #1291F3;
          }

          &.disabled {
            background-color: #eee;
            cursor: not-allowed;
            color: #999;
            border-color: #eee;
          }
        }
      }
    }

    .sku-divider {
      height: 1px;
      margin: 10px 0;
    }

    .buy-count {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 0;

      .buy-count_text {
        font-size: 12px;
        color: @text-color-gray;
      }
    }

  }
</style>
